import _ from 'lodash';
import { elogQueryAsync } from 'helpers/graphql';
import {fetchDownLimitSuccess} from './actions';

export const fetchDownLimitTasks = (data) => {
  const query = `query(
          $startDate: String
          $endDate: String
          $data: JSONString
          $limit: Int
          $offset: Int
        ) {
          usages(
            type: "sPOP-collection-download"
            startDate: $startDate
            endDate: $endDate
            data: $data
            limit: $limit
            offset: $offset
            order: desc
          ) {
            count
            data
          }
        }`
  return elogQueryAsync(query, {...data})
    .then((body) => {
      const _data = JSON.parse(_.get(body.data.usages, 'data'))
      return fetchDownLimitSuccess({data:_data})
    })
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/elog/tasks.js
 **/